const permisos = state => state.permisos;


export default {
  permisos,
};